module.exports = __webpack_public_path__ + "assets/CircleTangentCC.19b0484055c34858884d06ee506bca08.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/CircleTangentCC.gmt
// module id = 923
// module chunks = 0